import activityApi from '@/apis/activity'
import { useAdChannelStore } from '@/store/adChannelCode.store'
import { useAutoFormStore } from '@/store/autoForm.store'
import { useEffect } from 'react'

export const useAutoFormUseful = () => {
  const isUseful = useAutoFormStore(state => state.isUseful)
  const adChannelCode = useAdChannelStore(state => state.adChannelCode)
  useEffect(() => {
    if (!adChannelCode) {
      return
    }
    if (isUseful !== null) {
      return
    }
    useAutoFormStore.getState().checkAutoFormUseful(adChannelCode)
  }, [isUseful, adChannelCode])

  return isUseful
}